import { motion } from "framer-motion";
import type { CanvasRegion } from "./TutorialStepContent";

interface TutorialCanvasHintProps {
	region: CanvasRegion;
}

const REGION_POSITIONS: Record<CanvasRegion, { top: string; left: string }> = {
	center: { top: "45%", left: "50%" },
	top: { top: "25%", left: "50%" },
	bottom: { top: "65%", left: "50%" },
};

export function TutorialCanvasHint({ region }: TutorialCanvasHintProps) {
	const pos = REGION_POSITIONS[region];

	return (
		<motion.div
			className="tutorial-canvas-hint"
			style={{
				top: pos.top,
				left: pos.left,
				transform: "translate(-50%, -50%)",
			}}
			initial={{ opacity: 0, scale: 0.5 }}
			animate={{ opacity: 1, scale: 1 }}
			exit={{ opacity: 0, scale: 0.5 }}
			transition={{ type: "spring", damping: 20, stiffness: 200 }}
		>
			<div className="tutorial-canvas-hint__ring" />
			<div className="tutorial-canvas-hint__ring-inner" />
		</motion.div>
	);
}
